import { Fragment, useEffect, useState } from 'react';
import { ButtonComponent, CheckboxRadioComponent, InputComponent } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { getResendOTP, postVerifyOTP } from '../../redux/slices/auth-slice';
import { useFormik } from 'formik';
import { otpSchema } from '../../helpers/schemas';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

const OtpRadiosMain = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px;
`;

const Otp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user, loading } = useSelector((state) => state.loginUserReducer);

    const timerValue = 30;

    const initialValues = {
        otp: '',
        otpType: 'EMAIL',
    };

    const [states, setStates] = useState({
        timeLeft: timerValue,
        isDisabled: true,
        isVerifying: false,
    });

    const { handleChange, handleBlur, handleSubmit, values, touched, errors } = useFormik({
        initialValues: initialValues,
        validationSchema: otpSchema,
        onSubmit: (e) => {
            if (user) {
                setStates((old) => ({ ...old, isVerifying: true }));
                dispatch(postVerifyOTP({ user, body: e })).then((action) => {
                    if (action?.payload?.status === 200) {
                        setStates((old) => ({ ...old, isVerifying: false }));
                        if (action?.payload?.firstLogin) {
                            navigate("/user-operations/changepassword");
                        } else if (action?.payload) {
                            navigate("/app");
                        }
                    } else {
                        setStates((old) => ({ ...old, isVerifying: false }));
                    }
                });
            }
        }
    });

    const handleResendOtp = () => {
        if(user) {
            dispatch(getResendOTP({ user, type: values.otpType })).then((action) => {
                if (action?.payload?.status === 200) {
                    setStates((old) => ({ ...old, isDisabled: true, timeLeft: timerValue }));
                }
            });
        }
    };

    useEffect(() => {
        if (states.timeLeft > 0) {
            const timer = setInterval(() => {
                setStates((old) => ({ ...old, timeLeft: states.timeLeft - 1 }));
            }, 1000);

            return () => clearInterval(timer);
        } else {
            setStates((old) => ({ ...old, isDisabled: false }));
        }
    }, [states.timeLeft]);

    return (
        <Fragment>
            <div className='text-contain'>
                <h3>Verification</h3>
                <p>Please enter correct OTP code</p>
            </div>
            <form onSubmit={handleSubmit}>
                <div>
                    <InputComponent
                        label='OTP'
                        type='text'
                        name='otp'
                        value={values.otp}
                        placeholder='Enter OTP code'
                        autoFocus
                        onBlur={handleBlur}
                        onChange={handleChange}
                        mui
                    />
                    {
                        touched.otp && errors.otp && (
                            <p className="form-error">{errors.otp}</p>
                        )
                    }
                </div>

                {/* RADIO BUTTONS */}
                <div>
                    <OtpRadiosMain>
                        <CheckboxRadioComponent
                            type="radio"
                            label='Send OTP by SMS'
                            name="otpType"
                            value="SMS"
                            checked={values.otpType === 'SMS'}
                            onChange={handleChange}
                        />
                        <CheckboxRadioComponent
                            type="radio"
                            label='Send OTP by EMAIL'
                            name="otpType"
                            value="EMAIL"
                            checked={values.otpType === 'EMAIL'}
                            onChange={handleChange}
                        />
                    </OtpRadiosMain>
                    {
                        touched.otpType && errors.otpType && (
                            <p className="form-error">{errors.otpType}</p>
                        )
                    }
                </div>

                {/* BUTTONS */}
                <ButtonComponent fullWidth label={states.isVerifying ? 'Verifying' : 'Continue'} type='submit' upperCase disabled={loading} />
                <ButtonComponent fullWidth label={states.isDisabled ? `Resend OTP in ${states.timeLeft}s` : loading ? 'Sending' : 'Resend OTP'} type='button' onClick={handleResendOtp} outline disabled={states.isDisabled || loading} />
            </form>
        </Fragment>
    );
};

export default Otp;